import { api } from './api';

export enum AttributeDataType {
  Number = 0,
  Text = 1,
  Date = 2,
}

export interface CategoryAttributeDto {
  id: number;
  categoryId: number;
  /** Özniteliğin tanımlı olduğu kategori (miras alındıysa üst kategori) */
  sourceCategoryId: number;
  sourceCategoryName?: string;
  /** Bu kategoriye üst kategoriden miras alındıysa true */
  isInherited?: boolean;
  attributeCode: string;
  name: string;
  dataType: AttributeDataType;
  unit?: string;
  isFilterable: boolean;
  sortOrder: number;
  isActive: boolean;
}

export interface CreateCategoryAttributeRequest {
  categoryId: number;
  attributeCode: string;
  name: string;
  dataType: AttributeDataType;
  unit?: string;
  isFilterable?: boolean;
  sortOrder?: number;
}

export interface UpdateCategoryAttributeRequest {
  id: number;
  attributeCode: string;
  name: string;
  dataType: AttributeDataType;
  unit?: string;
  isFilterable: boolean;
  sortOrder: number;
}

export async function fetchCategoryAttributes(categoryId: number): Promise<CategoryAttributeDto[]> {
  const { data } = await api.get<CategoryAttributeDto[]>(`/categoryattributes/by-category/${categoryId}`);
  return data;
}

export async function createCategoryAttribute(
  request: CreateCategoryAttributeRequest
): Promise<CategoryAttributeDto> {
  const { data } = await api.post<CategoryAttributeDto>('/categoryattributes', request);
  return data;
}

export async function updateCategoryAttribute(
  id: number,
  request: UpdateCategoryAttributeRequest
): Promise<CategoryAttributeDto> {
  const { data } = await api.put<CategoryAttributeDto>(`/categoryattributes/${id}`, request);
  return data;
}

export async function deleteCategoryAttribute(id: number): Promise<void> {
  await api.delete(`/categoryattributes/${id}`);
}
